import { Button, Image, Progress, Slider } from "@nextui-org/react";
import React from "react";
import { deleteIcon2 } from "../../../assets";

const ImageUploaderView = ({ filename, fileInputRef, imageSrc, imageUploadStatus, handleFileChange, setInfluence, deleteReferImage }) => {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-4">
        <Button variant="solid" color="primary" size="md" onClick={() => fileInputRef.current.click()}>
          Choose file
        </Button>
        <p className=" truncate">{filename}</p>
        {imageSrc && (
          <Button isIconOnly variant="light" size="sm" aria-label="Delete" onClick={deleteReferImage}>
            <img src={deleteIcon2} alt="Delete" className="h-6 w-6" />
          </Button>
        )}
        <input ref={fileInputRef} type="file" className="hidden" accept="image/*" onChange={handleFileChange} />
      </div>
      {imageSrc && (
        <div className="flex w-full flex-col gap-[10px] pt-[15px]">
          {imageUploadStatus === "loading" && (
            <div>
              <Progress size="sm" isIndeterminate aria-label="Loading..." className="" />
              <p>Uploading...</p>
            </div>
          )}
          <div className="max-h-[300px] overflow-auto">
            <Image src={imageSrc} className={`w-1/2 object-contain`} alt="Refer image" />
          </div>
          <Slider
            label="Impact strength"
            color="primary"
            size="md"
            hideValue={true}
            onChange={setInfluence}
            minValue={0}
            step={0.01}
            maxValue={1}
            defaultValue={0.5}
            marks={[
              {
                value: 0,
                label: "Low",
              },
              {
                value: 0.5,
                label: "Default",
              },
              {
                value: 1,
                label: "Strong",
              },
            ]}
            classNames={{
              base: "text-white",
              label: "text-[16px]",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default ImageUploaderView;
